import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ProgressiveImage from "react-progressive-image";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import itemInfoStyles from "../../../assets/styles/components/itemInfoStyles";
import BreadCrumps from "../../../components/BreadCrups";
import NoContent from "../../../components/NoContent";
import SingleItemMenu from "../../../components/Menu/SingleItemMenu";

const styles = makeStyles((theme) => itemInfoStyles(theme));

export default (props) => {
	const { user, crumps } = props;

	const classes = styles();
	return (
		<div>
			{crumps && <BreadCrumps crumps={crumps} />}
			<div>
				{user.id ? (
					<>
						<Grid container className={classes.topSection}>
							<Grid item xs={12} container>
								<div>
									<img
										style={{
											objectFit: "cover",
											borderRadius: "6px",
										}}
										src={user.photoUrl}
										alt="No cover"
										className={classes.image}
									/>
								</div>
							</Grid>
							<Grid
								item
								xs={12}
								container
								direction="column"
								spacing={2}
								className={classes.infoSection}
							>
								<Grid item className={classes.textInfo}>
									<Grid item className={classes.actions}>
										<Grid container spacing={2} justifyContent="flex-end">
											<SingleItemMenu
												horiz
												background
												menu={props.actions}
												item={user}
											/>
										</Grid>
									</Grid>

									<Typography variant="h4" className={classes.texts}>
										{user.firstName} {user.lastName}
									</Typography>
									<Typography
										variant="subtitle1"
										className={classes.texts}
										style={{ padding: 0 }}
									>
										Title: {user.jobTitle}
									</Typography>
									<Typography
										variant="body1"
										className={classes.texts}
										style={{ padding: 0 }}
									>
										Email: {user.email}
									</Typography>
									<Typography
										variant="body1"
										className={classes.texts}
										style={{ padding: 0 }}
									>
										Phone: {user.phoneNumber}
									</Typography>
									<Typography
										variant="body1"
										className={classes.texts}
										style={{ padding: 0 }}
									>
										Status: {user.status}
									</Typography>
									<Typography
										variant="body1"
										className={classes.texts}
										style={{ padding: 0 }}
									>
										Last Modified: {moment(user.createdAt).fromNow()}
									</Typography>
								</Grid>
							</Grid>
						</Grid>
					</>
				) : (
					<NoContent title={"Can Not Find User"} />
				)}
			</div>
		</div>
	);
};
